import React, { useState, useRef } from 'react'
import { search, cross } from '../../assets/images/icons'
import { IconClose } from '../../assets/images/iconsV2'
import { MuiTextField } from '../index'
import { Wrapper, IconButtonWrapper } from './style'

const SearchBox = (props) => {
  const form = useRef()
  const { onClick } = props

  const [searchBoxValue, setSearchBoxValue] = useState('')
  const [showCancel, setShowCancel] = useState(false)

  const handlerChange = (e) => {
    setSearchBoxValue(e.target.value)
  }

  const handlerSearchClicked = (e) => {
    e.preventDefault()
    setShowCancel(true)
    onClick(searchBoxValue)
  }

  const handlerClearSearch = () => {
    setSearchBoxValue('')
    setShowCancel(false)
    onClick('')
  }

  return (
    <Wrapper className={`${showCancel ? 'showCrossButton' : ''}`}>
      <form ref={form} onSubmit={handlerSearchClicked} autoComplete='off'>
        <MuiTextField
          styletype='themeV2'
          placeholder='Search'
          name='searchBoxValue'
          onChange={handlerChange}
          type='text'
          value={searchBoxValue}
          size='small'
          variant='outlined'
          className='searchBox'
        />
        {searchBoxValue.length < 3 && (
          <IconButtonWrapper type='button' disabled={true} sx={{ opacity: 0.4 }}>
            <img src={search} width='15px' />
          </IconButtonWrapper>
        )}
        {searchBoxValue.length >= 3 && (
          <IconButtonWrapper type='submit' onClick={handlerSearchClicked}>
            <img src={search} width='15px' />
          </IconButtonWrapper>
        )}
        {searchBoxValue.length > 0 && showCancel && (
          <IconButtonWrapper type='button' onClick={handlerClearSearch} className='close'>
            <IconClose />
          </IconButtonWrapper>
        )}
      </form>
    </Wrapper>
  )
}
export default SearchBox
